import PropTypes from 'prop-types';
import PageBody from './elements/PageBody';
import PageHeader from './elements/PageHeader';
import './Page.scss';

/**
 * @param {JSX.Element} children components
 * @returns {JSX.Element} Page component
 */
function Page({ children }) {
    return (
        <div className='page-root'>
            {children}
        </div>
    );
}
Page.propTypes = {
    children: PropTypes.any.isRequired
};

Page.Header = PageHeader;
Page.Body = PageBody;

export default Page;